/* eslint-disable func-names */

/**
 * @fileOverview Cookie compliance
 * @author Selectra Front End Team
 * @version 1.0.0
 * @requires Github:js-cookie
 * @requires Polyfill:element-prototype-classlist 'Element.classList'
 */

import Cookies from 'js-cookie';

/**
* Show or hide cookie-compliance after checking if cookies are accepted
*/
export default function initCookieCompliance() {
  const
    cookieCompliance = document.querySelector( '.ac-cookie-compliance' ),
    cookieName = 'selectra-cookie-compliance-accepted';

  if ( cookieCompliance ) {
    // Cookie is not there
    if ( !Cookies.get( cookieName )) {
      // Show the cookie compliance
      cookieCompliance.classList.add( 'js-is--displayed' );
      // Listen click on cookie compliance cta and set the cookie
      const cookieCTA = document.querySelector( '.ac-cookie-compliance__cta' );
      if ( cookieCTA ) {
        cookieCTA.addEventListener( 'click', () => {
          // Set the cookie
          Cookies.set( cookieName, 'true',
            { expires: 30,
              domain: document.domain,
              secure: true
            }
          );
          // If cookie is present, hide cookie compliance
          if ( Cookies.get( cookieName )) {
            cookieCompliance.classList.remove( 'js-is--displayed' );
          }
        });
      }
    }
  }
}
